import { useDispatch, useSelector } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";
import { getGradeAPI } from "../../../assignmentAPI";

import { boldText } from "../../../../../utils/textUtils";

import UserInputBar from "../../widgets/UserInputBar";

const KorBlankPage = ({
  currentPage,
  currentIndex,
  setCurrentIndex,
  userInput,
  selectedBlankIndex,
  setUserInput,
  setSelectedBlankIndex,
  pageList,
  setPageList,
  setOverlayVisible,
}) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  const changeSelectedBlank = (element) => {
    if (element.isSubmitted) return alert("이미 정답 제출한 빈칸입니다.");
    setSelectedBlankIndex(element.index);
    currentPage.data.question.forEach((question) => {
      if (question.type === "blank") {
        if (question.index === element.index) {
          // isSubmitted가 false이면 input을, true이면 firstAttemptAnswer를 보여줌
          if (currentPage.isSubmitted && question.firstAttemptAnswer) {
            setUserInput(question.firstAttemptAnswer);
          } else {
            setUserInput(question.input);
          }
        }
      }
    });
  };

  const handleSubmit = async () => {
    if (currentPage.isSubmitted) return;

    if (userInput === "") return alert("답을 입력해주세요.");

    const response = await getGradeAPI({
      data: {
        eng: currentPage.data.eng,
        input: userInput,
        answer: currentPage.data.answer,
      },
      type: "kor_blank",
    });
    const isCorrect = response.is_correct === 1;

    const data = {
      ...currentPage.data,
      question: currentPage.data.question.map((element) => {
        if (element.type === "blank") {
          const isFirstAttempt = element.firstAttemptCorrect === undefined;
          
          if (isCorrect)
            return {
              ...element,
              isSubmitted: true,
              input: userInput,
              isCorrect: isCorrect,
              firstAttemptCorrect: isFirstAttempt ? isCorrect : element.firstAttemptCorrect,
              firstAttemptAnswer: isFirstAttempt ? userInput : element.firstAttemptAnswer,
            };
          else {
            return {
              ...element,
              isSubmitted: true,
              input: currentPage.data.answer,
              isCorrect: isCorrect,
              firstAttemptCorrect: isFirstAttempt ? isCorrect : element.firstAttemptCorrect,
              firstAttemptAnswer: isFirstAttempt ? userInput : element.firstAttemptAnswer,
            };
          }
        }
        return element;
      }),
    };

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          data: data,
          isSubmitted: true,
          isCorrect: isCorrect,
        };
      }
      return prevPage;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
    dispatch(
      updateSection({ sectionId: section.id, data: { answer: newPageList } })
    );

    setSelectedBlankIndex(-1);
    setOverlayVisible(true);
    setTimeout(() => {
      setOverlayVisible(false);
    }, 600);
  };

  const handleSetAnswer = () => {
    const nextElement = currentPage.data.question
      .filter(
        (element) => element.type === "blank" && element.isSubmitted === false
      )
      .find((element) => element.index > selectedBlankIndex);
    if (nextElement) {
      changeSelectedBlank(nextElement);
    }

    const newPageList = pageList.map((prevPage, index) => {
      if (index === currentIndex) {
        return {
          ...prevPage,
          data: {
            ...prevPage.data,
            question: prevPage.data.question.map((element) => {
              if (element.type === "blank") {
                if (element.index === selectedBlankIndex) {
                  return { ...element, input: userInput };
                }
              }
              return element;
            }),
          },
        };
      }
      return prevPage;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "30px",
      }}
    >
      <div
        style={{
          fontSize: "20px",
          marginBottom: "20px",
        }}
      >
        {"빈칸을 채우세요."}
      </div>
      <div
        style={{
          fontSize: "28px",
        }}
      >
        {currentPage.type !== "" &&
          currentPage.data.question.map((element, index) => {
            if (element.type === "text") {
              return element.content;
            } else if (element.type === "blank") {
              const userAnswer = element.input;
              const blankLength = element.length;
              const isSelected = element.index === selectedBlankIndex;

              return (
                <span
                  key={"kor_blank_" + index}
                  onClick={() => changeSelectedBlank(element)}
                  style={{
                    display: "inline-block",
                    minWidth: 20,
                    marginRight: 4,
                    marginLeft: 4,
                    cursor: "pointer",
                    letterSpacing: userAnswer === "" ? "0" : null,
                    backgroundColor: isSelected
                      ? "#e0ffe0"
                      : userAnswer === ""
                      ? "transparent"
                      : "#EBEBEB",
                  }}
                >
                  {userAnswer || "_".repeat(blankLength)}
                </span>
              );
            }
            return null;
          })}
      </div>
      <div
        style={{
          fontSize: "20px",
          color: "#737373",
        }}
      >
        {boldText({ text: currentPage.data.kor || currentPage.data.eng })}
      </div>
      <div style={{ position: "relative", width: "60%", marginTop: "50px" }}>
        <UserInputBar
          handleSetAnswer={handleSubmit}
          handleChange={handleChange}
          userInput={
            currentPage.isSubmitted && selectedBlankIndex >= 0
              ? currentPage.data.question.find(q => q.type === "blank" && q.index === selectedBlankIndex)?.firstAttemptAnswer || userInput
              : userInput
          }
          disabled={currentPage.isSubmitted}
          type={"analysis"}
        />
      </div>
      <button
        style={{
          position: "absolute", // 부모(80% width) 안에서 절대 위치
          bottom: "90px", // 최하단으로부터 10px 떨어짐
          right: "60px", // 우측으로부터 10px 떨어짐
          padding: "10px 35px",
          backgroundColor: currentPage.isSubmitted ? "#EBEBEB" : "#2D2D2D",
          color: currentPage.isSubmitted === true ? "#737373" : "white",
          border: "none",
          fontSize: "18px",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        onClick={() => handleSubmit()}
      >
        제출하기
      </button>
    </div>
  );
};

export default KorBlankPage;
